/**
 * Contextual Definitions
 * Membership: The final singular UI object based on assessing the user's subcriptions and teams status
 * Subscriptions: The subscription(s) the user is signed up for (They can have multiple subscriptions)
 * Teams Member/Owner: Users can own or be part of a team which influences their subscription.
 */

import { PRICING } from "data/links";

// constants
const ICON_PRO_TEXT = `unlimited icons. <a href="${PRICING}">Upgrade to Noun Pro Plus for unlimited icon sets and photos</a>`;
const ICON_PRO_TEXT_INDIVIDUAL = `You have ${ICON_PRO_TEXT}`;
const ICON_PRO_TEXT_TEAM = `Your team has unlimited icons. <a href="${PRICING}">Upgrade to Noun Team Plus for unlimited icon sets and photos</a>`;

// Subscriptions
const subscriptions = {
    freeMember: {
        title: "Free Member",
        upsellHtml: `<a href="${PRICING}">Get unlimited downloads free with Pro</a>`,
    },
    eduMember: {
        title: "Noun Pro EDU Member",
        upsellHtml: ICON_PRO_TEXT_INDIVIDUAL,
    },
    iconProMember: {
        title: "Noun Pro Member",
        upsellHtml: ICON_PRO_TEXT_INDIVIDUAL,
    },
    creatorProMember: {
        title: "Noun Pro Plus Member",
        upsellHtml: ``,
    },
};

// Teams Member/Owner
const teams = {
    iconProTeamMember: {
        title: "Noun Team Member",
        upsellHtml: ``,
    },
    iconProTeamOwner: {
        title: "Noun Team Owner",
        upsellHtml: ICON_PRO_TEXT_TEAM,
    },
    creatorProTeamMember: {
        title: "Noun Team Plus Member",
        upsellHtml: ``,
    },
    creatorProTeamOwner: {
        title: "Noun Team Plus Owner",
        upsellHtml: ``,
    },
};

// All Plans
export const plans = {
    ...subscriptions,
    ...teams,
};
